// extracted by mini-css-extract-plugin
module.exports = {"WrapperLayout":"Layout_WrapperLayout__dRLvR","WrapperPage":"Layout_WrapperPage__GIzkz"};